import { ChangeDetectorRef, Component, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataGridComponent } from '@app/shared/custom-component/data-grid/data-grid.component';
import { TabAction } from '@app/shared/custom-component/tabs/tabs.interface';
import { DataGridVO } from '@app/shared/custom-component/data-grid/data-grid.model';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs';
import { CommonService } from '@app/shared/services/common.service';
import { QUEUE_CONSTANTS } from '@app/shared/constants/queue.constants';
import { MaterialUIModule } from '@app/shared/modules/material-ui/material-ui.module';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ModalComponent } from '@app/shared/custom-component/modal/modal.component';
import { ModalConfig, modalContent, modalHeading, modalButtonTitles } from '@app/shared/constants/modal.model';
import { AbstractControl, ValidationErrors } from '@angular/forms';

@Component({
  selector: 'lookup-user-logs-tab',
  standalone: true,
  imports: [CommonModule, DataGridComponent, MaterialUIModule],
  templateUrl: './lookup-user-logs-tab.component.html',
  styleUrls: ['./lookup-user-logs-tab.component.scss']
})
export class LookupUserLogsTabComponent {
  auditLog: boolean = true;
  showAuditLogColumnChooser: boolean = false;
  tabActions: TabAction[] = [];
  showColumnChooser: boolean = false;
  allLogsColoumns: { key: string; label: string }[] = [];
  auditLogHeaders: any;
  visibleLogsColumns: { [key: string]: boolean } = {};
  private destroy$ = new Subject<void>();
  @ViewChild(DataGridComponent) dataGridComponent!: DataGridComponent;
  logsGridData: DataGridVO = new DataGridVO();
  data: any[] = [];
  @Input() auditGridData: any[] = [];
  customModal: NgbModalRef;

  constructor(private commonService: CommonService, private cd: ChangeDetectorRef, private modalService: NgbModal) { }
  ngOnInit(): void {
    this.commonService.getMetaData(QUEUE_CONSTANTS.AUDITLOGS_HEADERS).
      pipe(take(1), takeUntil(this.destroy$)).subscribe((res: any) => {
        this.auditLogHeaders = res.auditLogs;
        if (Array.isArray(res.auditLogs)) {

          this.allLogsColoumns = res.auditLogs.map((h: any) => ({
            key: h.dataField,
            label: h.caption || h.dataField
          }));
        }
        if (!this.visibleLogsColumns) {
          this.visibleLogsColumns = {};
        }
        this.allLogsColoumns.forEach(c => {
          if (typeof this.visibleLogsColumns[c.key] === 'undefined') {
            this.visibleLogsColumns[c.key] = true;
          }
        });
        this.updateDataGridConfig()

      });

  }

  closeAuditLogColumnChooser() {
    this.showAuditLogColumnChooser = false;
    this.updateDataGridConfig()
  }

  clickAuditLog() {
    this.auditLog = !this.auditLog;
  }

  onColumnClick(key: any) {
    const current = !!this.visibleLogsColumns[key];
    if (!this.visibleLogsColumns) this.visibleLogsColumns = {};
    this.visibleLogsColumns[key] = !current;
    this.updateDataGridConfig();
    this.cd.detectChanges();
  }
  viewModal(row) {
    console.log(row);
    const options: NgbModalOptions = {
      backdrop: "static",
      centered: true,
      size: "lg",
      windowClass: 'view-user-logs-modal'
    };
    this.customModal = this.modalService.open(ModalComponent, options);

    const modalConfig: ModalConfig = {
            buttons: [
              { text: modalButtonTitles.userlogsclose, code: 'N', btnOutline: true },
            ],
      heading: modalHeading.activityDetails,
      modalContent: modalContent.userActivityLogContent(row.field_name, row.new_value, row.old_value),
      hasTemplate: true,
      scrollable: true,
      hideCloseIcon: false
    };
    this.customModal.componentInstance.modalConfig = modalConfig;

  }
  validateDate = (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;
      let selectedDate: Date;
      const val = control.value;
      if (typeof val !== 'string') return null;
      if (val.includes('/')) {
        const parts = val.split('/');
        if (parts.length !== 3) return { futureDate: true };
        const month = parseInt(parts[0], 10);
        const day = parseInt(parts[1], 10);
        const year = parseInt(parts[2], 10);
        if (month < 1 || month > 12 || day < 1 || day > 31 || year < 1900) return { futureDate: true };
        selectedDate = new Date(year, month - 1, day);
        if (selectedDate.getMonth() !== month - 1 || selectedDate.getDate() !== day || selectedDate.getFullYear() !== year) return { futureDate: true };
      } else {
        selectedDate = new Date(val);
        if (isNaN(selectedDate.getTime())) return { futureDate: true };
      }
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      selectedDate.setHours(0, 0, 0, 0);
      if (selectedDate > today) return { futureDate: true };
    };

  downloadExcel() {
    const visibleCols = this.allLogsColoumns.filter(col => this.visibleLogsColumns[col.key]);
    if (visibleCols.length === 0) {
      window.alert('No columns selected for export');
      return;
    }
    if (
      this.dataGridComponent &&
      this.dataGridComponent.dataGrid &&
      this.dataGridComponent.dataGrid.instance &&
      typeof this.dataGridComponent.exportFilteredDataToExcel === 'function'
    ) {
      const columns = visibleCols.map(col => ({
        label: col.label,
        key: col.key
      }));
      const sheetName = 'AuditTrailLogs.xlsx';
      const gridInstance = this.dataGridComponent.dataGrid.instance;
      const oldPageSize = gridInstance.pageSize ? gridInstance.pageSize() : null;
      const totalCount = gridInstance.totalCount ? gridInstance.totalCount() : null;
      if (oldPageSize && totalCount && oldPageSize < totalCount) {
        gridInstance.pageSize(totalCount);
        setTimeout(() => {
          this.dataGridComponent.exportFilteredDataToExcel(columns, sheetName);
          setTimeout(() => {
            gridInstance.pageSize(oldPageSize);
          }, 500);
        }, 200);
        return;
      }
      this.dataGridComponent.exportFilteredDataToExcel(columns, sheetName);
      return;
    }
    const rows = Array.isArray(this.dateTimeModifier(this.auditGridData)) ? this.dateTimeModifier(this.auditGridData) : [];
    if (rows.length === 0) {
      window.alert('No data to export');
      return;
    }
    const exportRows = rows.map(row => {
      const filtered: any = {};
      visibleCols.forEach(col => {
        filtered[col.key] = row[col.key];
      });
      return filtered;
    });
    const exportColumns = visibleCols.map(col => ({
      label: col.label,
      key: col.key
    }));
    const sheetName = 'AuditLogs.xlsx';
    this.commonService.exportToExcel(exportRows, exportColumns, sheetName);

  }

  updateDataGridConfig() {
    this.logsGridData = DataGridVO.create({
      customHeaders: this.auditLogHeaders,
      data: this.dateTimeModifier(this.auditGridData),
      visibleColumns: this.visibleLogsColumns,
      showQueueActions: true,
      role: 'lookup-logs',
      activeTab: 'lookup-logs',
      disableApplicationClick: false
    });
  }
  private dateTimeModifier(dataRows: any[]) {
    const sorted = [...dataRows].sort((a, b) => {
      // time field is an ISO timestamp — parse directly for accurate sort
      const tsA = new Date(a.time ?? '').getTime();
      const tsB = new Date(b.time ?? '').getTime();
      // fall back to combining date + time if time alone is not a valid ISO string
      const dateA = isNaN(tsA) ? new Date(`${a.date} ${a.time ?? ''}`).getTime() : tsA;
      const dateB = isNaN(tsB) ? new Date(`${b.date} ${b.time ?? ''}`).getTime() : tsB;
      return (isNaN(dateB) ? 0 : dateB) - (isNaN(dateA) ? 0 : dateA);
    });
    this.data = sorted.map((item) => ({ ...item, time: this.modifyTime(item.time) }));
    return this.data;
  }
  private modifyTime(time: string) {
    const d = new Date(time);
    const formattedTime = d.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    })
    return formattedTime;
  }
}